import { Component, OnInit, OnDestroy } from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../service-areas-service/service-areas.service';

@Component({
  selector: 'app-service-areas-listing',
  templateUrl: './service-areas-listing.component.html',
  styleUrls: ['./service-areas-listing.component.css']
})
export class ServiceAreasListingComponent implements OnInit {
  search;
  selectedStatus: any = "active";
  serviceAreas = [];

  constructor(
    private serviceArea: ServiceAreasService) {
  }

  ngOnInit() {
    this.getServiceAreas()
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: this.selectedStatus})
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreas = data
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }


  ngOnDestroy(): void {
  }

  onChangeStatus() {
    this.getServiceAreas();
  }

}
